<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { Target, Globe, Shield, Briefcase } from 'lucide-vue-next';

const expertiseIcons = [Target, Briefcase, Shield, Globe]

const { t, tm } = useI18n()
const features = tm('expertiseSection.categories') as any[]
</script>

<template>
  <section id="expertise" class="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white">
    <div class="container mx-auto px-4 max-w-7xl">
      <div class="text-center mb-16">
        <h2 class="text-3xl font-bold mb-12">
          {{ t('expertiseSection.title') }}
          <div class="h-1 bg-red-500 w-20 mx-auto mt-2"></div>
        </h2>
        <p class="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
          {{ t('expertiseSection.subtitle') }}
        </p>
      </div>

      <div class="grid lg:grid-cols-2 gap-8">
        <div 
          v-for="(category, catIndex) in features"
          :key="catIndex"
          class="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300"
        >
          <div class="p-8">
            <h3 class="text-2xl font-bold text-gray-900 mb-6">
              {{ category.category }}
            </h3>
            <div class="space-y-6">
              <div
                v-for="(item, itemIndex) in category.items"
                :key="itemIndex"
                class="flex items-start space-x-5 p-5 bg-gray-50 rounded-xl hover:bg-white transition-colors"
              >
                <div class="flex-shrink-0">
                  <div class="p-3 rounded-xl bg-gradient-to-br">
                    <component 
                      :is="expertiseIcons[itemIndex]"
                    />
                  </div>
                </div>
                <div>
                  <h4 class="text-lg font-semibold text-gray-900 mb-1">
                    {{ item.title }}
                  </h4>
                  <p class="text-gray-600 leading-relaxed">
                    {{ item.text }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
